import { createContext } from "react";

const currentLanguageContext = createContext(null);

export default currentLanguageContext;
